module.exports = {
  missingCompany: 'Company is required',
  missingCompanyName: 'Company Name is required',
  missingAppResName: 'App Resource Name is required',
  errorsAppResType: 'App Resource Type is required',
  missingAppResSubModel: 'App Resource Subscription Model is required',
  missingCompanyPhone: 'Company Phone is required',
  missingCompanyCountry: 'Country is required',
  missingCompanyTown: 'Town/City is required',
  missingCompanyPostal: 'Postal Code is required',
  missingCompanyAddress: 'Address Line 1 is required',
  missingFetchConf: 'Fetch Configuration Frequency (In Min.)',
  missingLang: 'Default Language is requierd',
  missingChargeType: 'Delivery Charge Type is requierd',
  missingChargePerMile: 'Delivery Charge Per Mile is requierd',
  missingDomain: 'Domain is required',
  missingMinPersons: 'Min # of Persons is required',
  missingMaxPersons: 'Max # of Persons is required',
  missingCategory: 'Table Category is required',
  missingCurrency: 'Currency is required',
  missingCuisines: 'Cuisines are required',
  missingMaxDist: 'Max Delivery Distance is required',
  missingDomainType: 'Domain Type is required',
  missingRegisteredOn: 'Registration Date is required',
  missingTemplateType: 'Template Type is required',
  missingTemplate: 'Template is required',
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  missingPlanet: 'WebShop Planet is required',
  missingPayment: 'Payment Type is required',
  missingPayments: 'Payment Types are required',
  missingOrder: 'Order Type is required',
  missingCatalogVersion: 'Catalog Version is required',
  missingSubscription: 'Subscription is required',
  missingCatalogView: 'Catalog View is required',
  missingName: 'WebShop Name is required',
  missingDeliery: 'Minimum Delivery Amount is required',
  missingEmailID: 'Email ID is required',
  missingMerchantId: 'Merchant ID is required',
  missingStoreId: 'Store ID is required',
  missingPass: 'Password is required',
  missingPreSharedKey: 'Pre Shared Key is required',
  missingLicenseType: 'License Type is required',
  missingSunLicense: 'Sun License System Version is required',
  missingConcurrent: 'Number of Concurrent Users is required',
  missingActivationDate: 'Activation Date is required',
  missingExpiryDate: 'Expiry Date is required',
  missingPrinterName: 'Printer Name is required',
  missingManufacturer: 'Manufacturer is required',
  missingModel: 'Model is required',
  missingPrintServerName: 'Print Server Name is required',
  missingPrinters: 'Printers are required',
  missingHolder: 'Account Holder Name is required',
  missingDicount: 'Max Discount Percentage is required',
  missingUserName: 'Username is required',
  missingDefaultPrinter: 'Default Printer is required',
  missingCallerIdName: 'CallerID Server Name is required',
  missingCorporationName: 'Corporation Name is required',
  missingCompanies: 'Companies are required',
  missingTemplateName: 'Template Name is required',
  missingPrintTemplateType: 'Print Template Type is required',
  missingNoPrints: 'Number of Prints is required',
  missingMonth: 'Month is required',
  missingYear: 'Year is required',
  missingMainaway: 'Mainaway Template is required',
  missingUnpaidBill: 'Unpaid Bill Template is required',
  missingItemTemplate: 'Item Template is required',
  missingTaxTemplate: 'Tax Template is required',
  missingLabelTemplate: 'Label Template is required',
  missingKitchenTemplate: 'Kitchen Template is required',
  missingDriverTemplate: 'Driver Template is required',
  missingFromDate: 'From Date is required',
  missingToDate: 'To Date is required',
  missingStartDate: 'Start Date is required',
  missingEndDate: 'End Date is required',
  missingCfgUpdate: 'Configuration Update Type is required',
  missingTableMin: 'Table Idle Time In Minutes is required',
  missingOrderSubmission: 'Order Submission Allowed From is required',
  missingPricingGroups: 'Pricing Groups are required',
  wrongInterval: 'Backup Interval has wrong value',
  validTime: 'Time is not in valid format',
  validEmail: 'E-mail must be valid',
  noData: 'No data available',
  missingRuleName: 'Rule Name is required',
  serverUrl: 'Server URL is required',
  primaryCompany: 'Primary Company is required',
  timeError: 'Time value is not valid',
  required: 'Field is required',
  notValid: 'Value is not valid',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  noVatRates: 'You must enter at least one VAT rate',
  wrongVAT: 'VAT rates must be at least one of the following',
  missingImageName: 'Image Name is required',
  missingImageLabel: 'Image Label is required',
  missingdistanceUnit: 'Distance Unit is required',
  wrongVatUK: 'VAT rates must be at least one of the following',
  missingHint: 'Missing mandatory HtmlHint',
  missingAllHint: 'Please add the mandatory fields needed for the T&C respective data protection pages',
  wrongEmail: 'Book keeper Email for is not in good format',
  emptyValue: 'cannot be empty',
  postal: 'postal code not found!',
  validPostalOrAddress: 'Postal code or address is not valid, please change',
  notValidUrl: 'Url format is not valid!',
  missingTimezone: 'Timezone is missing!',
  missingTerminals: 'At least one Terminal is required',
  missingApiKey: 'Api Key is required',
  missingUsernameP: 'Username is required',
  validConfirmEmail: 'E-mails are not the same',
  noAvailableTemplate: 'No available template for import',
  inputOutputLangs: 'You must select Input and Output languages!',
  inputOutputLangsSame: 'Input and Output languages cannot be the same!',
};




// WEBPACK FOOTER //
// ./src/lang/en/errors.js